angular.module('impactx.search').controller('SearchListThemeWorldCtrl', SearchListThemeWorldCtrl);
SearchListThemeWorldCtrl.$inject = [
    '$scope',
    'searchFilter',
    'SearchService',
    'AppConfiguration',
    'SearchFilter',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    'BackService'
];

function SearchListThemeWorldCtrl($scope, searchFilter, SearchService, AppConfiguration, SearchFilter, dataGen, ToolbarService,
                                  TranslationService, BackService) {
    var self = this;
    searchFilter.currentPage = searchFilter.pageSearchThemeWorld;
    ToolbarService.showSearchFilterToggle();
    self.resetPageNumber = {value: false};

    $scope.search = function (index, selectedSort) {
        if (!index) {
            self.resetPageNumber.value = true;
        }
        $scope.data = undefined;
        var filters = SearchFilter.getFilters();
        self.filter = filters;
        if (filters) {
            filters.sort.selected = selectedSort;
        }
        return dataGen.postAsForm($scope, {filters: filters}, "/search/themworlds").then(function (result) {
            self.initialized = true;
            $scope.data = result.data;
            $scope.trns = result.trns;
            defineButtons();
        })
    };
    $scope.search();

    $scope.hasThemeWorlds = function() {
        return $scope.data && $scope.data.searchResults && $scope.data.searchResults.numOfThemeWorlds &&
            $scope.data.searchResults.numOfThemeWorlds > 0;
    };

    self.displayAllResultsAsList = function () {
        return AppConfiguration.get('displayAllResultsAsList');
    };

    self.back = function () {
        BackService.back();
        self.filter.listFilters = SearchFilterStorage.getFreshFilter().listFilters;
    }

    function defineButtons() {
        var buttonDefinition = [
            {label: TranslationService.get("back"), action: self.back, type: 'dialogaction'}
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }
}
